import { Text } from "@/components/ui/text";
import { format } from "@/lib/utils";

export type UserTimestampProps = {
  user?:
    | { username?: string | null }
    | { manufacturer?: string | null; model?: string | null }
    | null;
  timestamp?: string | Date | null;
  fromNow?: boolean;
  emptyUserText?: string;
};

export function UserTimestamp({
  user,
  timestamp,
  fromNow,
  emptyUserText = "system",
}: UserTimestampProps) {
  let userText = emptyUserText;

  if (user && "username" in user && user.username) {
    userText = user.username;
  }

  if (user && "manufacturer" in user && user.manufacturer) {
    userText = `${user.manufacturer} ${user.model}`;
  }

  return (
    <Text size="sm" muted className="inline-flex items-baseline">
      {userText} @ {timestamp ? format(timestamp, { fromNow }) : "-"}
    </Text>
  );
}
